import localeEn from '@/app/billing-management/locales/en'
import localeAr from '@/app/billing-management/locales/ar'
import { billingGroupAssignmentService } from "@/app/billing-management/shared/services/bg-assignment-service.js";
import { SaveResultEnums } from '@/app/billing-management/shared/config/billing-management-enums.js';

export default {
    name: "save-config-modal",
    data() {
        return {
            isNotCoverd: this.IsNotCoverd
        }
    },
    props: ['contractorID', 'IsNotCoverd'],
    methods: {
        cancelPopup() {
            this.$refs['save-config-modal'].hide();
            this.$parent.openConfigModelFlag = false;
        },
        saveConfig() {
            this.$parent.isLoading = true;
            billingGroupAssignmentService.AddContractorIsCoveredConfigration(this.contractorID, this.isNotCoverd, (result) => {
                this.$parent.isLoading = false;
                if (result.data == SaveResultEnums().Success) {
                    this.$refs['save-config-modal'].hide();
                    this.$parent.openConfigModelFlag = false;
                    this.$emit('saveConfig', true, this.isNotCoverd);
                }
                else if (result.data == SaveResultEnums().Failure) {
                    this.$parent.showPopupNotification(`<h6>${this.$i18n.t('Common.Error')}</h6><p>${this.$i18n.t('Common.Error')}</p>`, 'error');
                }
                else if (result.data == SaveResultEnums().Concurrency) {
                    this.$parent.showPopupNotification(`<h6>${this.$i18n.t('Common.Warning')}</h6><p>${this.$i18n.t('Common.Concurrency')}</p>`, 'warning');
                }

            })
            
        }
    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    }
};